import { MessageSquare, Search, FileCheck, Truck } from 'lucide-react'
import { STORE_NAME } from '../config'

const steps = [
  {
    icon: MessageSquare,
    title: 'Tell us what you need',
    text: 'Send your product specs, volumes, destination and certification requirements through the inquiry list or the contact form. The more detail you share, the sharper our first quote.'
  },
  {
    icon: Search,
    title: 'We source and quote',
    text: `Our procurement desk at ${STORE_NAME} matches your spec to vetted producers and returns a landed-cost quote — typically within one business day, with alternatives if your spec is tight.`
  },
  {
    icon: FileCheck,
    title: 'Quality and compliance',
    text: 'Inspection reports, certificates of analysis, origin and dietary documentation are verified before shipment. Nothing leaves origin until the paperwork matches the contract.'
  },
  {
    icon: Truck,
    title: 'Freight and delivery',
    text: 'Container, pallet or parcel — coordinated door-to-door with tracking and customs clearance included. You get one delivery window and one accountable partner.'
  }
]

export function ProcessSteps() {
  return (
    <section className="bg-brand-navy px-4 py-16 text-white sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <span className="mb-3 inline-block rounded-full border border-brand-gold/40 bg-brand-gold/15 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-gold-light">
          Our process
        </span>
        <h2 className="font-display text-2xl font-bold sm:text-3xl">
          How we work with you
        </h2>
        <p className="mt-4 max-w-2xl text-white/70">
          At {STORE_NAME}, every order follows the same four-stage playbook — so you always know what happens next and who owns it.
        </p>
        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, i) => (
            <div key={step.title} className="relative">
              {i < steps.length - 1 && (
                <div className="absolute left-1/2 top-6 hidden h-px w-full bg-white/15 lg:block" style={{ left: '60%', width: '80%' }} />
              )}
              <div className="relative">
                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-gold text-brand-navy">
                  <step.icon className="h-6 w-6" />
                </div>
                <span className="absolute -top-2 -right-2 flex h-6 w-6 items-center justify-center rounded-full bg-white/10 text-xs font-bold text-brand-gold-light">
                  {i + 1}
                </span>
              </div>
              <h3 className="mt-5 font-display text-lg font-semibold">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/70">{step.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
